
import { frontendLogger } from '../services/frontendLogger.js';

export const handleShare = async (urlOrEvent) => {
  let shareUrl = window.location.href;
  // If a string is passed, use it as the URL. If an event or nothing, use current page.
  if (typeof urlOrEvent === 'string') {
    shareUrl = urlOrEvent;
  }
  const shareText = `Discover Andlegur – the sanctuary for healing, purpose, and awakening.\n${shareUrl}`;
  if (navigator.share) {
    try {
      await navigator.share({
        title: "Andlegur Sanctuary",
        text: shareText,
        url: shareUrl,
      });
    } catch (err) {
      // Don't log AbortError (user cancelled), only log actual errors
      if (err.name !== 'AbortError') {
        frontendLogger.error('Share failed', {
          component: 'ShareUtils',
          action: 'handleShare',
          error: err.message,
          stack: err.stack
        });
      }
    }
  } else {
    // fallback (like copy-to-clipboard)
    handleCopy(shareUrl);
  }
};

export const handleCopy = async (url) => {
  const shareUrl = url || window.location.href;
  try {
    await navigator.clipboard.writeText(shareUrl);
    alert("Andlegur link copied to clipboard!");
  } catch (err) {
    frontendLogger.error('Copy failed', {
      component: 'ShareUtils',
      action: 'copyToClipboard',
      error: err.message,
      stack: err.stack
    });
  }
};
